<template>
	<div class="page" :class="{ [appInfo]: true,'iHearStyle':appConfig.iHearStyle, ios: env.isIOS }">
		<div :class="fixTopClass">
			<div class="leftPart">
				<img class="topIcon" :src="currentIcon" alt="" />
				<div class="topBoxCenter">
					<div class="topPart">{{ currentTitle }}</div>
					<div class="bottomPart">{{ currentDesc }}</div>
				</div>
			</div>
			<div :class="btnClass" @click="open" :style="computedPrimaryBg"> Download</div>
		</div>
		<AudioContent :bookId="$route.query.bookId" ref="AudioContent" />
	</div>
</template>

<script>
import AudioContent from '@/views/components/audio-content'
import {getChannel} from "@/utils/getChannel";
import {getAppConfig} from "@/utils";
export default{
    components:{
        AudioContent
    },
    data(){
        return {
            appInfo:'',
            currentIcon:'',
            currentTitle:'',
            currentDesc:'',
            appConfig:{}
        }
    },
    created(){
        this.appInfo = getChannel()
        let config = getAppConfig()
        this.appConfig=config
        if (this.appInfo == 'readNow') {
            this.currentIcon = this.env.isAndroid ? require('@/assets/icons/readNow.png') : require('@/assets/icons/readNow-logo.png')
        } else {
            this.currentIcon = config.topIcon
        }

        this.currentTitle = config.title
        this.currentDesc = config.desc
    },
    computed: {
        fixTopClass() {
            return {
                fixTop: true,
                [this.appInfo]: true,
                ios: this.env.isIOS,
            }
        },
        btnClass() {
            return {
                topBtn: true,
                [this.appInfo]: true,
                ios: this.env.isIOS,
            }
        },
        bottomBtnClass() {
            return {
                btn: true,
                [this.appInfo]: true,
                ios: this.env.isIOS,
            }
        },
        computedPrimaryBg(){
            return this.appConfig.PrimaryColor && this.appConfig.iHearStyle ? {
                backgroundColor:this.appConfig.PrimaryColor
            } : {}
        },
    },
    methods:{
        open(){
            this.$refs.AudioContent.open()
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/bookShare.scss';
</style>
